import React from "react";
import Lottie from "lottie-react";
import planeBoardingPassAnimation from "../../assets/lotties/plane-boarding-pass.json";

const PaymentLoader = ({ loading, text }) => {
  if (!loading) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(2px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        pointerEvents: "auto",
      }}
      onClick={(e) => {
        // Prevent clicks from passing through to background elements
        e.stopPropagation();
        e.preventDefault();
      }}
      onMouseDown={(e) => {
        // Prevent mouse interactions with background
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <div
        style={{
          pointerEvents: "auto",
          width: "300px",
          height: "300px",
        }}
      >
        <Lottie
          animationData={planeBoardingPassAnimation}
          loop={true}
          autoplay={true}
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </div>
      {text && (
        <div
          style={{
            marginTop: "20px",
            color: "#ffffff",
            fontSize: "18px",
            fontWeight: "500",
            textAlign: "center",
            pointerEvents: "none",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default PaymentLoader;
